module.exports = __webpack_public_path__ + "img/carousel-sample-1.bd778c4e.png";